module.exports = require('events').EventEmitter;



//////////////////
// WEBPACK FOOTER
// ./node_modules/readable-stream/lib/internal/streams/stream-browser.js
// module id = ./node_modules/readable-stream/lib/internal/streams/stream-browser.js
// module chunks = 0 1 2